import { useTranslation } from 'react-i18next'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { PasserbyBillList } from './list/passerby-bill.list'

type PasserbyBillListDrawerProps = {
  onClose: () => void
  open: boolean
  propertyId: string
  onPasserbyBillItemClick: (passerbyBillId: string) => void
}

export default function PasserbyBillListDrawer({ onClose, open, onPasserbyBillItemClick, propertyId }: PasserbyBillListDrawerProps) {
  const { t } = useTranslation()
  return (
    <FormLayout
      appearance={{
        type: 'DRAWER',
        open,
        onClose,
        tight: true,
      }}
      title={t('pms.booking.passerby-bill.list.title')}
      toolbar={<></>}
    >
      <PasserbyBillList propertyId={propertyId} onPasserbyBillItemClick={onPasserbyBillItemClick} />
    </FormLayout>
  )
}
